import { VIEW_ONLY_WRITE_REFUSAL_MESSAGE } from "@common/userWorkspaceRoles";
import { useViewOnlyRefusal } from "./useViewOnlyRefusal";

/**
 * View-only wins: when the acting user is view-only, a disabled-write tooltip
 * says the one standard sentence ahead of any more specific reason. An
 * unresolved role falls through to `specificReason` because `isViewOnly` is
 * `role === VIEW_ONLY` (never a positive predicate — see `useViewOnlyRefusal`),
 * so an admin mid-load keeps today's tooltip.
 *
 * Pure form for call sites that already know `isViewOnly` (e.g. a role derived
 * from `entity.members` on an org page with no active workspace).
 */
export function viewOnlyTooltipReason(params: {
    isViewOnly: boolean;
    specificReason: string;
}): string {
    return params.isViewOnly
        ? VIEW_ONLY_WRITE_REFUSAL_MESSAGE
        : params.specificReason;
}

export function useViewOnlyTooltipReason(specificReason: string): string {
    const { isViewOnly } = useViewOnlyRefusal();
    return viewOnlyTooltipReason({ isViewOnly, specificReason });
}
